import React from 'react'
import { CardActions, CardContent, Divider, Typography } from '@material-ui/core'
import { createStyles, makeStyles } from '@material-ui/core/styles';
import { Card } from '@material-ui/core';
import jMoment from 'moment-jalaali';
import RonadIcons from '../iconComponent';
import { downloadFile } from '../../api/ticket/get';
import { updateTicketContent } from '../../api/ticket/put';
import handleNotfication from '../../utils/handleNotfication';
import handleError from '../../utils/handleError';
const useStyles = makeStyles(theme =>
  createStyles({
    adminCard: {
      position: 'relative',
      width: '50%',
      boxShadow: 'none !important',
      marginBottom: '8px',
      borderRadius: '10px',
      backgroundColor: "#2F4858",
      color: "#fff",
      borderTopLeftRadius: "0px",
    },
    userCard: {
      position: 'relative',
      width: '50%',
      boxShadow: 'none !important',
      border: '1px solid lightgray',
      marginBottom: '8px',
      borderRadius: '10px',
      backgroundColor: "#fff",
      borderTopLeftRadius: "0px",
    },
    container: {
      display: "grid",
      width: "100%",
    },
    userName: {
      margin: "5px",
      fontWeight: 700
    },
    adminUserName: {
      margin: "5px",
      fontWeight: 700,
    },
    adminDate: {
    },
    hideLabel: {
      position: 'absolute',
      top: '5px',
      right: '5px',
      color: '#2F4858',
      backgroundColor: "#fff",
      borderRadius: '50%',
      textAlign: 'center',
      width: "18px",
      height: "18px"
    },
    optionLabel: {
      position: 'absolute',
      bottom: '-3px',
      right: '5px',
    }
  })
);

type Data = {
  id: number
  body: string
  status: string
  user: object
  createdAt: string
  updatedAt: string
  attachment?: string
  isHide: boolean
}

const TicketCards = ({data, ticketId, reloadMessage}: {data: Data, ticketId: string, reloadMessage: () => void}) => {
  const {id, body, status, user,createdAt, updatedAt, attachment, isHide} = data
  const classes = useStyles();

  const clickAttachment = async (name: string) => {    
    downloadFile(id, ticketId, name).then(response => response.blob())
    .then(myBlob => {
      download(myBlob, name.split('/')[2]);
    });
  }

  const download = (blob, fileName) => {
    const link = document.createElement('a');
    link.href = URL.createObjectURL(blob);
    link.download = fileName;
    document.body.append(link);
    link.click();
    link.remove();
    setTimeout(() => URL.revokeObjectURL(link.href), 7000);
  };

  const changeVisibility = async () => {
    try {
      await updateTicketContent(id, {isHide: !isHide})
      handleNotfication('پیام با موفقیت ویرایش شد.', 'success')
      reloadMessage()
    } catch (error) {
      handleError(error)
    }
  }

  return (
    <div className={classes.container}>
      <Typography className={user.type === 'PARTNER' ? classes.userName : classes.adminUserName}>
        {user?.username}
      </Typography>
      <Card className={user.type === 'PARTNER' ? classes.userCard : classes.adminCard}>
        {isHide && <span className={classes.hideLabel}>
          H
        </span>}
        {user.type !== 'PARTNER' && <span className={classes.optionLabel}>
          <RonadIcons name={isHide ? 'eye' : 'eye-off'} color='white' size='16px' onClick={changeVisibility}/>
        </span>}
        <CardContent style={{ padding: '16px', whiteSpace: 'pre-wrap' }}>
          <Typography>
            {body}
          </Typography>
        </CardContent>
        {attachment && <><Divider />
        <CardActions>
          <Typography>
            <a style={{ textDecoration: 'none', color: 'blue', cursor: 'pointer' }} onClick={() => clickAttachment(attachment)}>{attachment.split('/')[2]}</a>
            <RonadIcons name='link-03' size={'15px'} style={{ marginRight: '8px' }} />
          </Typography>
        </CardActions></>}
      </Card>
      <Typography className={user.type !== 'PARTNER' && classes.adminDate}>
        {jMoment(createdAt, 'YYYY-M-D HH:mm')
          .add(3, 'hours')
          .add(30, 'minutes')
          .locale('fa')
          .format('HH:mm jYYYY/jMM/jDD ')}
      </Typography>
    </div>
  )
}

export default TicketCards